import * as Blockly from "blockly/core";
import { registerRestrictions } from "../../../restrictions";

const blockName = "get_all_channel_channel_name";

const blockData = {
    "message0": "Channel Name",
    "args0": [
    ],
    "colour": "#a55b80",
    "output": "String",
    "tooltip": "",
    "helpUrl": ""
};

Blockly.Blocks[blockName] = {
    init: function() {
        this.jsonInit(blockData);
    }
};

Blockly.JavaScript[blockName] = function(){
return [ `c.name`, Blockly.JavaScript.ORDER_NONE ];
};
registerRestrictions(blockName, [
    {
        type: "hasparent",
        message: "RES_GET_ALL_CHANNEL_PARENT",
        types: [
            "s4d_get_all_channel"
        ]
    }
]);
